<template>
  <div id="item-meta">
    <slot></slot>
  </div>
</template>

<script>
import { debounce } from 'lodash';

export default {
  props: ["search-items"],
  computed: {
    couponType() {
      return this.$store.state.couponType;
    },
    couponTypes() {
      return this.$store.state.couponTypes;
    },
    currentCustomer() {
      return this.$store.state.currentCustomer;
    },
  },
  watch: {
    couponType: {
      handler: function() {
        this.debouncedGetItems();
      }
    },
    currentCustomer: {
      handler: function() {
        this.debouncedGetItems();
      }
    }
  },
  methods: {
    debouncedGetItems: debounce(function() {
      if (this.searchItems) {
        this.$store.dispatch("getItems", this.searchItems);
      } else {
        this.$store.dispatch("getItems");
      }
    }, 100),
  },
  mounted() {
    if (this.searchItems) {
      this.$store.dispatch("getItems", this.searchItems);
    } else {
      this.$store.dispatch("getItems");
    }
    this.$store.dispatch("getCurrentCart");
  },
};
</script>
